import Modal from './Modal'
import { ThreeCircles } from 'react-loader-spinner'

const Loading = ({ loading }) => {
    return (
        <Modal
            open={loading}
            sx={{
                display: 'flex', justifyContent: 'center', alignItems: 'center',
                width: "100%", height: "100%", aspectRatio: 1,
                borderRadius: "20px",
            }}
            containerSx={{ pt: 0, pb: 0 }}
        >
            <ThreeCircles
                visible={true}
                height="100"
                width="100"
                color="#1C236D"
                ariaLabel="three-circles-loading"
                wrapperStyle={{}}
                wrapperClass=""
            />
        </Modal>
    )
}

export default Loading